/**
 * ContactButton - 浮屏广告插件组件
 * 提供可拖拽的悬浮按钮，包含"咨询"和"教程"两个功能入口
 * 
 * @component
 * @prop {Number} type - 系统类型标识，决定咨询链接跳转地址（1:互联中台 2:溯源系统 3:速速云签 4:人如云 5:海鸥云 其他:客服中心），默认值 0
 * 
 * 支持鼠标拖拽移动位置，拖拽距离超过阈值时判定为拖拽操作而非点击
 */
<!-- 浮屏广告 -->
<template>
    <div id="contact-plugin" :style="styleObject" @mousedown="startDrag">
        <button>
            <div class="btn-top" @click="redirectToContact">
                <img class="btn-img" src="@/assets/advertisement/consult.png" />
                <div class="text-consult">咨询</div>
            </div>
            <div class="btn-bottom" @click="openCourse">
                <img src="@/assets/advertisement/course.png" />
                <div class="text">教程</div>
            </div>
        </button>
    </div>
</template>

<script>
export default {
    name: "ContactButton",
    props: {
        type: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            isDragging: false,
            startX: 0,
            startY: 0,
            initialRight: 0,
            initialTop: 0,
            right: "25px",
            top: "500px",
            dragging: false,
            dragThreshold: 5, // 拖拽的最小距离阈值
        };
    },
    methods: {
        startDrag(event) {
            this.isDragging = true;
            this.startX = event.clientX;
            this.startY = event.clientY;
            this.initialRight = parseInt(
                window.getComputedStyle(this.$el).right,
                10
            );
            this.initialTop = parseInt(
                window.getComputedStyle(this.$el).top,
                10
            );
            document.addEventListener("mousemove", this.onDrag);
            document.addEventListener("mouseup", this.stopDrag);
        },
        onDrag(event) {
            if (!this.isDragging) return;
            const point = event.touches ? event.touches[0] : event;
            const deltaX = point.clientX - this.startX;
            const deltaY = point.clientY - this.startY;
            if (
                Math.abs(deltaX) > this.dragThreshold ||
                Math.abs(deltaY) > this.dragThreshold
            ) {
                this.dragging = true;
            }
            const el = this.$el;
            const maxRight = window.innerWidth - el.offsetWidth;
            const maxTop = window.innerHeight - el.offsetHeight;
            this.right = `${Math.max(
                0,
                Math.min(maxRight, this.initialRight - deltaX)
            )}px`;
            this.top = `${Math.max(
                0,
                Math.min(maxTop, this.initialTop + deltaY)
            )}px`;
        },
        stopDrag() {
            // 延迟设置 isDragging 为 false 以防止立即触发 click
            setTimeout(() => {
                this.isDragging = false;
            }, 0);
            document.removeEventListener("mousemove", this.onDrag);
            document.removeEventListener("mouseup", this.stopDrag);

            // 如果拖拽的距离不足以被认定为拖拽，则重置 dragging 标志
            if (!this.dragging) {
                this.dragging = false;
            }
        },
        redirectToContact(event) {
            // 互联中台：1 溯源系统：2 速速云签：3 人如云：4 海鸥云：5  其余：客服中心
            if (!this.dragging) {
                if (this.type == 1) {
                    window.open(
                        "https://y.hulianzaowu.com/news/txtlist_i127v.html",
                        "_blank"
                    );
                } else if (this.type == 2) {
                    window.open(
                        "https://y.hulianzaowu.com/news/txtlist_i126v.html",
                        "_blank"
                    );
                } else if (this.type == 3) {
                    window.open(
                        "https://y.hulianzaowu.com/news/txtlist_i125v.html",
                        "_blank"
                    );
                } else if (this.type == 4) {
                    window.open(
                        "https://y.hulianzaowu.com/news/txtlist_i124v.html",
                        "_blank"
                    );
                } else if (this.type == 5) {
                    window.open(
                        "https://y.hulianzaowu.com/news/txtlist_i123v.html",
                        "_blank"
                    );
                } else {
                    window.open(
                        "https://y.hulianzaowu.com/news/newslist_j25v_p1v.html",
                        "_blank"
                    );
                }
            }
            // 重置 dragging 标志
            this.dragging = false;
        },
        openCourse() {
            window.open("https://docs.qq.com/doc/DYXdLVk1yR2JHSWZP", "_blank");
        },
    },
    computed: {
        styleObject() {
            return {
                position: "fixed",
                right: this.right,
                top: this.top,
                zIndex: 999999,
            };
        },
    },
};
</script>

<style scoped>
#contact-plugin {
    cursor: move;
}
button {
    padding: 30px 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    box-shadow: -2px 0px 13px 0px rgba(123, 123, 123, 0.39);
    border: none;
    border-radius: 30px;
    cursor: pointer;
    font-size: 15px;
    color: #666666;
}
.btn-top {
    padding-bottom: 10px;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #d9d9d9;
}
.btn-bottom {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
}
.btn-img {
    width: 30px;
    height: 30px;
}
.text-consult {
    margin-top: 3px;
    color: #3384fe;
}
.text {
    margin-top: 3px;
}
button:focus {
    outline: none; /* 移除聚焦状态下的 outline */
}
</style>
